document.addEventListener("DOMContentLoaded", function() {
  // Initialize the carousel
  const carousels = document.querySelectorAll('.announcement-bar-main-carousel');
  
  if (carousels) {
    carousels.forEach(carousel => {
      var flkty = new Flickity(carousel, {
        cellAlign: 'center',
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 3000,
        contain: true,
        adaptiveHeight: true,
        on: {
          ready: function() {
            setTimeout(function() {
              var hiddenCells = carousel.querySelectorAll('.carousel-cell:nth-child(n+2)');
              hiddenCells.forEach(cell => {
                cell.style.removeProperty("display");
              });
              flkty.reloadCells(); // Recalculate layout after cells are shown
            }, 100); // Delay to ensure proper layout
          }
        }
      });
    })
  }
})

if (window.innerWidth > 767 ) {
document.addEventListener("DOMContentLoaded", function() {
  const menuItems = document.querySelectorAll('.custom-megamenu-item');
  const submenuItems = document.querySelectorAll('.sub-custom-megamenu-item');

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseover', function() {
      menuItem.classList.add('active');
      const datatrigger = menuItem.getAttribute('data-trigger');

      submenuItems.forEach((submenuItem) => {
        const datatarget = submenuItem.getAttribute('data-target');
        if(datatrigger == datatarget ){
          submenuItem.style.display = "block";
          submenuItem.classList.add("active");
        }else{
          submenuItem.style.display = "none";
          submenuItem.classList.remove("active");
        }
      });
    });
  });

  document.addEventListener('mouseover', function(event) {
    const isMenuHovered = Array.from(menuItems).some(menuItem => menuItem.contains(event.target));
    const isSubmenuHovered = Array.from(submenuItems).some(submenuItem => submenuItem.contains(event.target));

    if (!isMenuHovered && !isSubmenuHovered) {
      submenuItems.forEach((submenuItem) => {
        submenuItem.style.display = "none";
        submenuItem.classList.remove("active");
      });
    }
  });
});
}else{
  document.addEventListener("DOMContentLoaded", function() {
    const menuItems = document.querySelectorAll('.custom-megamenu-item');
    const submenuItems = document.querySelectorAll('.sub-custom-megamenu-item');
  
    function handleClick(event) {
  
      menuItems.forEach(item => item.classList.remove('active')); // Remove 'active' class from all menu items
  
      const menuItem = event.currentTarget;
      menuItem.classList.add('active');
      const datatrigger = menuItem.getAttribute('data-trigger');
  
      submenuItems.forEach((submenuItem) => {
        const datatarget = submenuItem.getAttribute('data-target');
        if (datatrigger == datatarget) {
          event.preventDefault();
          event.stopPropagation(); // Stop propagation of the click event
          submenuItem.style.display = "block";
          submenuItem.classList.add("active");
        } else {
          submenuItem.style.display = "none";
          submenuItem.classList.remove("active");
        }
      });
    }
  
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener('click', handleClick);
    });
  
    document.addEventListener('click', function(event) {
      const isMenuHovered = Array.from(menuItems).some(menuItem => menuItem.contains(event.target));
      const isSubmenuHovered = Array.from(submenuItems).some(submenuItem => submenuItem.contains(event.target));
  
      if (!isMenuHovered && !isSubmenuHovered) {
        submenuItems.forEach((submenuItem) => {
          submenuItem.style.display = "none";
          submenuItem.classList.remove("active");
        });
      }
    });
  });
}

function MatchHeight() {
  $('.product-card-wrap-custom').matchHeight({});
  $('.product-price-wrap-custom').matchHeight({});
}

$(document).ready(function() {
  MatchHeight();
});